/**
 * We Do Things Differently (leaves-26b5)
 * 1:1 Serve Robotics framed video player:
 * - centered max ~1600px (not full-bleed)
 * - 16:9 frame, full video (no crop)
 * - L-corner copy top-left
 * - corner controls: mute and fullscreen only
 * Palette around frame: European stone (not pure black page).
 */
(function () {
  'use strict';

  if (!document.body || document.documentElement.dataset.leavesServeDiff === '1') return;
  document.documentElement.dataset.leavesServeDiff = '1';

  var SECTION_ID = 'leaves-26b5';
  var TITLE_MATCH = /we\s+do\s+things\s+differently/i;

  function textOf(node) {
    return String((node && node.textContent) || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function hideOriginal(node) {
    if (!node) return;
    node.classList.add('leaves-original-replaced');
    node.setAttribute('aria-hidden', 'true');
    node.setAttribute('hidden', '');
  }

  function findSection() {
    var byId = document.querySelector('#leaves-home [data-section-id="' + SECTION_ID + '"]');
    if (byId) return byId;
    var headings = document.querySelectorAll('#leaves-home [data-leaves-type="FlexSection"] h3, #leaves-home h3');
    for (var i = 0; i < headings.length; i += 1) {
      if (TITLE_MATCH.test(textOf(headings[i]))) {
        return headings[i].closest('[data-leaves-type="FlexSection"]');
      }
    }
    return document.querySelector('[data-section-id="' + SECTION_ID + '"]');
  }

  function collectIcons(section) {
    var icons = [];
    var items = section.querySelectorAll('[data-leaves-type="ContentListItem"]');
    Array.prototype.forEach.call(items, function (item) {
      var label = textOf(item.querySelector('h3, h4, [data-leaves-type="Heading2"]'));
      if (!label) return;
      var svg = item.querySelector('svg');
      icons.push({ label: label, iconHtml: svg ? svg.outerHTML : '' });
    });
    return icons;
  }

  function findVideoBlock(section) {
    return (
      section.querySelector('[data-leaves-type="HTML.Video2"]') ||
      section.querySelector('.leaves-video-wrapper') ||
      section.querySelector('video') ||
      section.querySelector('.leaves-153_') ||
      section.querySelector('.leaves-154_')
    );
  }

  function posterFrom(block) {
    if (!block) return '';
    var img = block.querySelector('.leaves-video-cover-button img, img');
    if (img) {
      var src = img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || '';
      if (src && src.indexOf('{{') === -1) return src;
    }
    var coverBtn = block.querySelector('.leaves-video-cover-button');
    if (coverBtn) {
      var bg = window.getComputedStyle(coverBtn).backgroundImage || '';
      var m = bg.match(/url\(["']?([^"')]+)["']?\)/i);
      if (m) return m[1];
    }
    return '';
  }

  function videoSrcFrom(block) {
    if (!block) return '';
    var video = block.querySelector('video');
    if (!video) return '';
    return (
      video.getAttribute('src') ||
      video.currentSrc ||
      (video.getAttribute('data-src') || '').split('#')[0] ||
      ''
    );
  }

  function formatTime(sec) {
    if (!isFinite(sec) || sec < 0) sec = 0;
    var s = Math.floor(sec % 60);
    var m = Math.floor(sec / 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function iconRowHtml(icons) {
    if (!icons.length) return '';
    return (
      '<div class="leaves-serve-diff__icons">' +
      icons
        .map(function (icon) {
          return (
            '<div class="leaves-serve-diff__icon">' +
            (icon.iconHtml || '') +
            '<span class="leaves-serve-diff__icon-label">' +
            escapeHtml(icon.label) +
            '</span></div>'
          );
        })
        .join('') +
      '</div>'
    );
  }

  function controlsHtml() {
    return (
      '<div class="leaves-serve-diff__controls" data-leaves-controls>' +
      '<input class="leaves-serve-diff__vol" data-vol type="range" min="0" max="1" step="0.05" value="0" aria-label="Volume">' +
      '<button type="button" class="leaves-serve-diff__ctrl-btn" data-act="mute" aria-label="Mute">' +
      '<svg class="i-vol" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M5 9v6h4l5 5V4L9 9H5zm11.5 3c0-1.8-1-3.3-2.5-4v8c1.5-.7 2.5-2.2 2.5-4z"/></svg>' +
      '<svg class="i-mute" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" hidden><path d="M16.5 12c0-1.8-1-3.3-2.5-4v2.2l2.5 2.5V12zm2.5 0c0 .9-.2 1.8-.5 2.6l1.5 1.5c.6-1.2 1-2.6 1-4.1 0-3.5-2-6.5-5-8.1v2.2c2.1 1.3 3.5 3.7 3.5 6.4zM4.3 3 3 4.3 7.7 9H5v6h4l5 5v-6.7l4.7 4.7 1.3-1.3L4.3 3zM14 3.7v2.2L10.8 8.9 14 12.1V3.7z"/></svg>' +
      '</button>' +
      '<button type="button" class="leaves-serve-diff__ctrl-btn" data-act="fs" aria-label="Fullscreen">' +
      '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>' +
      '</button>' +
      '</div>'
    );
  }

  function build(section) {
    if (section.querySelector('.leaves-serve-diff')) return;

    var flex = section.querySelector('.leaves-flex-section') || section;
    var titleNode = null;
    var headings = flex.querySelectorAll('h3, h2, [data-leaves-type="Heading2"]');
    Array.prototype.forEach.call(headings, function (h) {
      if (TITLE_MATCH.test(textOf(h))) titleNode = h;
    });
    var title = textOf(titleNode) || 'We Do Things Differently';
    var leadNode =
      (titleNode && titleNode.parentElement && titleNode.parentElement.querySelector('p')) ||
      flex.querySelector('p[data-leaves-type="Paragraph3"], p');
    var lead = textOf(leadNode);
    var icons = collectIcons(section);
    var videoBlock = findVideoBlock(section);
    var poster = posterFrom(videoBlock || section);
    var src = videoSrcFrom(videoBlock || section);

    var root = document.createElement('div');
    root.className = 'leaves-serve-diff';
    root.setAttribute('data-leaves-serve-diff', '');

    root.innerHTML =
      '<div class="leaves-serve-diff__frame">' +
      '<div class="leaves-serve-diff__media" data-leaves-serve-media>' +
      (poster
        ? '<img class="leaves-serve-diff__poster" src="' +
          escapeHtml(poster).replace(/'/g, '&#39;') +
          '" alt="" decoding="async">'
        : '') +
      '<video class="leaves-serve-diff__video-el" playsinline webkit-playsinline loop preload="metadata"' +
      (poster ? ' poster="' + escapeHtml(poster).replace(/'/g, '&#39;') + '"' : '') +
      (src ? ' src="' + escapeHtml(src).replace(/'/g, '&#39;') + '"' : '') +
      '></video>' +
      '</div>' +
      '<div class="leaves-serve-diff__scrim" aria-hidden="true"></div>' +
      '<div class="leaves-serve-diff__overlay">' +
      '<div class="leaves-serve-diff__stack">' +
      '<div class="leaves-serve-diff__lmark" aria-hidden="true">' +
      '<svg viewBox="0 0 29 29" fill="none"><path d="M0.5 28.5V8.5C0.5 4.08172 4.08172 0.5 8.5 0.5H28.5" stroke="currentColor"/></svg>' +
      '<div class="leaves-serve-diff__hairline"></div>' +
      '</div>' +
      '<div class="leaves-serve-diff__corner">' +
      '<h2 class="leaves-serve-diff__title">' +
      escapeHtml(title) +
      '</h2>' +
      (lead ? '<p class="leaves-serve-diff__lead">' + escapeHtml(lead) + '</p>' : '') +
      iconRowHtml(icons) +
      '</div>' +
      '</div>' +
      '</div>' +
      controlsHtml() +
      '</div>';

    Array.prototype.forEach.call(flex.children, function (child) {
      if (child === root) return;
      hideOriginal(child);
    });

    flex.insertBefore(root, flex.firstChild);
    section.classList.add('leaves-serve-diff-host');

    wirePlayer(root, videoBlock);
  }

  function wirePlayer(root, videoBlock) {
    var video = root.querySelector('.leaves-serve-diff__video-el');
    var poster = root.querySelector('.leaves-serve-diff__poster');
    var frame = root.querySelector('.leaves-serve-diff__frame');
    var playBtn = root.querySelector('[data-act="play"]');
    var muteBtn = root.querySelector('[data-act="mute"]');
    var fsBtn = root.querySelector('[data-act="fs"]');
    var seek = root.querySelector('[data-seek]');
    var fill = root.querySelector('[data-fill]');
    var thumb = root.querySelector('[data-thumb]');
    var timeEl = root.querySelector('[data-time]');
    var vol = root.querySelector('[data-vol]');
    var iPlay = playBtn && playBtn.querySelector('.i-play');
    var iPause = playBtn && playBtn.querySelector('.i-pause');
    var iVol = muteBtn.querySelector('.i-vol');
    var iMute = muteBtn.querySelector('.i-mute');

    // Fallback: pull data-src from PageFly video if our src empty
    if (video && !video.getAttribute('src') && videoBlock) {
      var pfVideo = videoBlock.querySelector('video');
      var dataSrc = pfVideo && (pfVideo.getAttribute('data-src') || '').split('#')[0];
      if (dataSrc) video.src = dataSrc;
    }

    video.muted = true;
    if (vol) vol.value = '0';

    function setPlaying(on) {
      if (iPlay) iPlay.hidden = !!on;
      if (iPause) iPause.hidden = !on;
      if (playBtn) playBtn.setAttribute('aria-label', on ? 'Pause' : 'Play');
      root.classList.toggle('is-playing', !!on);
      if (on && poster) poster.hidden = true;
    }

    function setMuted(on) {
      video.muted = !!on;
      if (iVol) iVol.hidden = !!on;
      if (iMute) iMute.hidden = !on;
      muteBtn.setAttribute('aria-label', on ? 'Unmute' : 'Mute');
      if (vol) vol.value = on ? '0' : String(video.volume || 1);
    }

    function updateProgress() {
      var d = video.duration || 0;
      var t = video.currentTime || 0;
      var pct = d ? (t / d) * 100 : 0;
      if (fill) fill.style.width = pct + '%';
      if (thumb) thumb.style.left = pct + '%';
      if (seek && !seek._dragging) seek.value = String(Math.round(pct * 10));
      if (timeEl) timeEl.textContent = formatTime(t);
    }

    function play() {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    function pause() {
      video.pause();
    }

    if (playBtn) {
      playBtn.addEventListener('click', function () {
        if (video.paused) play();
        else pause();
      });
    }

    muteBtn.addEventListener('click', function () {
      setMuted(!video.muted);
      if (!video.muted && video.volume === 0) {
        video.volume = 0.8;
        if (vol) vol.value = '0.8';
      }
    });

    if (vol) {
      vol.addEventListener('input', function () {
        var v = parseFloat(vol.value);
        video.volume = v;
        setMuted(v === 0);
      });
    }

    if (seek) {
      seek.addEventListener('pointerdown', function () {
        seek._dragging = true;
      });
      seek.addEventListener('pointerup', function () {
        seek._dragging = false;
      });
      seek.addEventListener('input', function () {
        var d = video.duration || 0;
        if (!d) return;
        var pct = parseFloat(seek.value) / 1000;
        video.currentTime = pct * d;
        updateProgress();
      });
    }

    fsBtn.addEventListener('click', function () {
      var target = frame;
      if (!document.fullscreenElement) {
        if (target.requestFullscreen) target.requestFullscreen();
        else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
      } else if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    });

    video.addEventListener('play', function () {
      setPlaying(true);
    });
    video.addEventListener('pause', function () {
      setPlaying(false);
    });
    video.addEventListener('timeupdate', updateProgress);
    video.addEventListener('loadedmetadata', updateProgress);

    // Click video surface toggles play (Serve-like)
    root.querySelector('.leaves-serve-diff__media').addEventListener('click', function (e) {
      if (e.target.closest('.leaves-serve-diff__controls')) return;
      if (video.paused) play();
      else pause();
    });

    // Autoplay muted when in view (theme = video)
    function tryAutoplay() {
      setMuted(true);
      play();
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              tryAutoplay();
              io.disconnect();
            }
          });
        },
        { threshold: 0.35 }
      );
      io.observe(root);
    } else {
      window.setTimeout(tryAutoplay, 500);
    }
  }

  function run() {
    var section = findSection();
    if (!section) return false;
    if (section.querySelector('.leaves-serve-diff')) return true;
    build(section);
    return !!section.querySelector('.leaves-serve-diff');
  }

  var booted = false;
  function boot() {
    if (run()) return;
    if (booted) return;
    booted = true;
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (run() || tries > 40) window.clearInterval(timer);
    }, 80);
  }

  if (document.readyState === 'loading') {
    if (document.body) boot();
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
